import axios from 'axios';

const API_BASE_URL = window.location.origin + '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export const login = (username: string, password: string) =>
  api.post('/login/', { username, password });

export const fetchDocuments = () => api.get('/documents/');

export const uploadDocument = (formData: FormData) =>
  api.post('/documents/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteDocument = (id: number) => api.delete(`/documents/${id}/`);

export const logout = () => {
  localStorage.removeItem('token');
};

export default api;
